import './local'
import './App.scss'
import pageLanguage from './functions/pageLanguage'
import { getAppIndex } from './functions/getAlgoliaIndex'
import { AppFilter } from './functions/getAlgoliaFilter'
import algoliasearch from 'algoliasearch/lite'
import {
  InstantSearch,
  Configure,
  connectStateResults,
} from 'react-instantsearch-dom'

import HomePage from './components/HomePage'
import { Spin } from 'antd'

const searchClient = algoliasearch(
  'A47E3BWDPH',
  'e5c93dfd73b094a9553e9a07349b774e'
)

const appStyle = {
  direction: pageLanguage() === 'ar' ? 'rtl' : 'ltr',
}

const StateResults = ({ searchResults }) => {
  const hasResults = searchResults
  const nbHits = searchResults && searchResults.nbHits

  return (
    <div>
      <div hidden={!hasResults}>
        <HomePage />
      </div>
      <div hidden={hasResults}>
        <Spin className="spinLoader" size="large" />
      </div>
    </div>
  )
}

const CustomStateResults = connectStateResults(StateResults)

function App() {
  return (
    <div className="App top-mobily" id="App" style={appStyle}>
      <InstantSearch searchClient={searchClient} indexName={getAppIndex()}>
        <Configure hitsPerPage={32} filters={AppFilter()} />
        <div className="mobily-to-top">
          <CustomStateResults />
        </div>
      </InstantSearch>
    </div>
  )
}

export default App
